/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import ModalBodyLayout from '../ModalBodyLayout';

const InfoPopup = ({ openScreen, options }) => (
  <ModalBodyLayout
    onPrevClick={() => openScreen(options?.mainScreen)}
    withBack={options?.withBack}
    title={options?.title}
    isButtonInFooter={options?.isButtonInFooter}
    isScrollable={options?.isScrollable}>
    <div className={`${!options?.title ? 'mt-3' : ''}`}>{options?.content()}</div>
  </ModalBodyLayout>
);

export default InfoPopup;

InfoPopup.propTypes = {
  openScreen: PropTypes.func,
  options: PropTypes.object.isRequired,
};

InfoPopup.defaultProps = {
  openScreen: () => {},
};
